<template>
  <h5 class="back-closd-link">
    <a
      :href="$t('login.BackToClosd.urlClosd')"
      data-locator="back-to-closd-link"
      class="text-text-tertiary font-weight-bold font-size"
    >
      {{$t('login.BackToClosd.backClosd')}}
    </a>
  </h5>
</template>

<script>
export default {
  name: 'BackToClosd',
}
</script>

<style scoped>
.back-closd-link a{
    text-decoration: none;
  font-size: 14px;
}
</style>
